// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LogMgrOutlinedSvg from "@fishx/icons-svg/es/asn/LogMgrOutlined";
import FishxIcon from '../components/FishxIcon';

var LogMgrOutlined = function LogMgrOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LogMgrOutlinedSvg
  }));
};

LogMgrOutlined.displayName = 'LogMgrOutlined';
export default React.forwardRef(LogMgrOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LogMgrOutlined.js
// module id = 3065
// module chunks = 0